/**
 * @file wq-mega-menu.js
 * @description Data-driven mega menu — fetches wq-nav-data.json and renders
 *              3 grouped mega tabs (Lasers, Optics, Systems) + link tabs.
 *              Desktop: hover-triggered panels. Mobile: drawer accordion.
 * @sprint 2 | Task 2.2, 2.5 | Updated: Taxonomy Restructuring Task 5
 */
window.WQ = window.WQ || {};

window.WQ.MegaMenu = (() => {
  'use strict';

  let initialized = false;
  let closeTimer = null;
  let activeTabId = null;
  const CLOSE_DELAY = 300;

  /* ── SVG icon map (keyed by nav JSON `icon` field) ── */
  const ICONS = {
    'laser': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 10h12m2-3l2 3-2 3M6 7l-2 3 2 3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'laser-cw': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 10h16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="10" cy="10" r="3" stroke="currentColor" stroke-width="1.2"/></svg>',
    'laser-pulsed': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 13h3l2-6 2 6 2-6 2 6h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'opa': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 10h4m6 0h4M10 3v4m0 6v4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="10" cy="10" r="3" stroke="currentColor" stroke-width="1.2"/></svg>',
    'pulse': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 10h4l2-6 4 12 2-6h4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'mirror': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 16L16 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M4 10l6-6M8 14l6-6" stroke="currentColor" stroke-width="1" opacity="0.4" stroke-linecap="round"/></svg>',
    'lens': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><ellipse cx="10" cy="10" rx="4" ry="8" stroke="currentColor" stroke-width="1.2"/><line x1="2" y1="10" x2="18" y2="10" stroke="currentColor" stroke-width="1.2"/></svg>',
    'grating': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 3v14M8 3v14M11 3v14M14 3v14" stroke="currentColor" stroke-width="1" opacity="0.6"/><path d="M2 10h16" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
    'polarizer': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.2"/><path d="M10 3v14M5 5l10 10" stroke="currentColor" stroke-width="1"/></svg>',
    'crystal': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2l6 5v6l-6 5-6-5V7z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path d="M10 2v16M4 7l12 6M4 13l12-6" stroke="currentColor" stroke-width="0.8" opacity="0.4"/></svg>',
    'filter': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.2"/><path d="M3 8h14M3 12h14" stroke="currentColor" stroke-width="1" opacity="0.4"/></svg>',
    'coating': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="4" y="6" width="12" height="8" rx="1" stroke="currentColor" stroke-width="1.2"/><path d="M6 6V4M14 6V4M6 14v2M14 14v2" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>',
    'fiber': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M2 14c4-8 12-8 16 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M2 10c4-4 12-4 16 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" opacity="0.5"/></svg>',
    'mount': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="6" width="14" height="8" rx="1" stroke="currentColor" stroke-width="1.2"/><line x1="10" y1="14" x2="10" y2="18" stroke="currentColor" stroke-width="1.2"/><line x1="6" y1="18" x2="14" y2="18" stroke="currentColor" stroke-width="1.2"/></svg>',
    'detector': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="4" y="3" width="12" height="14" rx="1" stroke="currentColor" stroke-width="1.2"/><circle cx="10" cy="10" r="3" stroke="currentColor" stroke-width="1.2"/></svg>',
    'thz': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 10c2-4 4 4 6 0s4 4 6 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
    'quantum': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="2" fill="currentColor"/><ellipse cx="10" cy="10" rx="8" ry="3" stroke="currentColor" stroke-width="1"/><ellipse cx="10" cy="10" rx="8" ry="3" stroke="currentColor" stroke-width="1" transform="rotate(60 10 10)"/><ellipse cx="10" cy="10" rx="8" ry="3" stroke="currentColor" stroke-width="1" transform="rotate(120 10 10)"/></svg>',
    'application': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 4h5v5H4zM11 4h5v5h-5zM4 11h5v5H4zM11 11h5v5h-5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>',
    'default': '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.2"/></svg>'
  };

  const CHEVRON_DOWN = '<svg class="wq-mega-menu__chevron" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ARROW_RIGHT = '<svg class="wq-mega-menu__arrow" width="6" height="10" viewBox="0 0 6 10"><path d="M1 1l4 4-4 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ── Utility ── */
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function getIcon(name) {
    return ICONS[name] || ICONS['default'];
  }

  /* ── Init ── */
  async function init() {
    if (initialized) return;
    initialized = true;

    var nav = document.querySelector('.wq-mega-menu');
    if (!nav) return;

    var navUrl = nav.dataset.navUrl;
    if (!navUrl) return;

    try {
      var resp = await fetch(navUrl);
      var navData = await resp.json();
      buildMenu(nav, navData);
    } catch (err) {
      console.error('WQ MegaMenu: Failed to load nav data', err);
    }
  }

  /* ── Build entire menu from JSON ── */
  function buildMenu(nav, navData) {
    var tabs = navData.tabs || [];
    var groups = navData.menuGroups || [];
    var categories = navData.categories || [];

    /* Build category lookup: id → category object */
    var catMap = {};
    categories.forEach(function(cat) { catMap[cat.id] = cat; });

    /* 1. Build desktop tab buttons */
    buildTabs(nav, tabs, groups);

    /* 2. Build desktop dropdown panels (one per mega group) */
    buildDropdownPanels(nav, groups, catMap);

    /* 3. Build mobile drawer */
    buildMobileDrawer(nav, tabs, groups, catMap);

    /* 4. Attach event handlers */
    initDesktopEvents(nav, groups);
    initMobileEvents(nav);
    initKeyboard(nav);
  }

  /* ── linkFor — resolve nav entry to URL.
   * Supports a `url` override field (e.g. `/pages/...`) for non-collection
   * destinations like tutorials, vendor catalogs, knowledge pages.
   * Falls back to `/collections/<handle>` for normal collection nodes.
   * Added 2026-05-06 to surface chirped-mirror tutorials + UFI/Optoman catalogs in nav.
   */
  function linkFor(node) {
    if (node && node.url) return node.url;
    if (node && node.handle) return '/collections/' + node.handle;
    return '#';
  }

  /* ── 1. Desktop tabs ── */
  function buildTabs(nav, tabs, groups) {
    var container = nav.querySelector('#wq-mega-tabs');
    if (!container) return;

    var html = '';
    tabs.forEach(function(tab) {
      if (tab.type === 'mega') {
        html += '<li class="wq-mega-menu__tab wq-mega-menu__tab--mega" role="none" data-mega-group="' + esc(tab.id) + '">'
          + '<button class="wq-mega-menu__tab-btn" role="menuitem" aria-haspopup="true" aria-expanded="false" data-mega-trigger="' + esc(tab.id) + '">'
          + esc(tab.label) + ' ' + CHEVRON_DOWN
          + '</button></li>';
      } else if (tab.type === 'link') {
        html += '<li class="wq-mega-menu__tab" role="none">'
          + '<a class="wq-mega-menu__tab-link" href="' + esc(tab.url) + '" role="menuitem">' + esc(tab.label) + '</a></li>';
      }
    });

    container.innerHTML = html;
  }

  /* ── 2. Desktop dropdown panels ── */
  function buildDropdownPanels(nav, groups, catMap) {
    var container = nav.querySelector('#wq-mega-dropdown-inner');
    if (!container) return;

    /* Build one panel set per group (L1 list + L2 panels) */
    var html = '';
    groups.forEach(function(group) {
      html += '<div class="wq-mega-menu__group-panel" data-group="' + esc(group.id) + '" aria-hidden="true">';

      /* Left: L1 list */
      html += '<ul class="wq-mega-menu__l1-list" role="none">';
      group.categories.forEach(function(catId) {
        var cat = catMap[catId];
        if (!cat) return;
        html += '<li class="wq-mega-menu__l1-item" data-category="' + esc(cat.id) + '" role="none">'
          + '<a href="' + esc(linkFor(cat)) + '" class="wq-mega-menu__l1-link" role="menuitem" aria-haspopup="true">'
          + '<span class="wq-mega-menu__l1-icon">' + getIcon(cat.icon) + '</span>'
          + '<span class="wq-mega-menu__l1-text">' + esc(cat.label) + '</span>'
          + ARROW_RIGHT
          + '</a></li>';
      });
      html += '</ul>';

      /* Right: L2 panels (one per L1 in this group) */
      html += '<div class="wq-mega-menu__l2-panels">';
      group.categories.forEach(function(catId) {
        var cat = catMap[catId];
        if (!cat || !cat.children) return;

        html += '<div class="wq-mega-menu__l2-panel" data-panel="' + esc(cat.id) + '" aria-hidden="true">';
        html += '<h3 class="wq-mega-menu__l2-heading"><a href="' + esc(linkFor(cat)) + '">' + esc(cat.label) + '</a></h3>';
        html += '<ul class="wq-mega-menu__l2-list">';

        cat.children.forEach(function(child) {
          if (child.children && child.children.length > 0 && !child.isLeaf) {
            /* L2 with L3 children */
            html += '<li class="wq-mega-menu__l2-item--has-children">';
            html += '<a href="' + esc(linkFor(child)) + '" class="wq-mega-menu__l2-link">' + esc(child.label) + '</a>';
            html += '<ul class="wq-mega-menu__l3-list">';
            child.children.forEach(function(l3) {
              html += '<li><a href="' + esc(linkFor(l3)) + '" class="wq-mega-menu__l3-link">' + esc(l3.label) + '</a></li>';
            });
            html += '</ul></li>';
          } else {
            html += '<li><a href="' + esc(linkFor(child)) + '" class="wq-mega-menu__l2-link">' + esc(child.label) + '</a></li>';
          }
        });

        html += '</ul>';
        html += '<a href="' + esc(linkFor(cat)) + '" class="wq-mega-menu__view-all">View All ' + esc(cat.label) + ' &rarr;</a>';
        html += '</div>';
      });
      html += '</div>'; /* end l2-panels */

      html += '</div>'; /* end group-panel */
    });

    container.innerHTML = html;
  }

  /* ── 3. Mobile drawer ── */
  function buildMobileDrawer(nav, tabs, groups, catMap) {
    var container = nav.querySelector('#wq-mega-drawer-body');
    if (!container) return;

    var html = '';

    /* Mega groups as accordion sections */
    groups.forEach(function(group) {
      html += '<div class="wq-mega-menu__drawer-group">';
      html += '<h3 class="wq-mega-menu__drawer-group-title">' + esc(group.label) + '</h3>';
      html += '<ul class="wq-mega-menu__drawer-l1">';

      group.categories.forEach(function(catId) {
        var cat = catMap[catId];
        if (!cat) return;

        var hasChildren = cat.children && cat.children.length > 0;

        html += '<li class="wq-mega-menu__drawer-item">';
        if (hasChildren) {
          html += '<button class="wq-mega-menu__drawer-l1-btn" aria-expanded="false" data-drawer-category="' + esc(cat.id) + '">'
            + esc(cat.label)
            + '<svg class="wq-mega-menu__drawer-chevron" width="12" height="12" viewBox="0 0 12 12"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            + '</button>';
          html += '<ul class="wq-mega-menu__drawer-l2" aria-hidden="true">';

          cat.children.forEach(function(child) {
            if (child.children && child.children.length > 0 && !child.isLeaf) {
              /* L2 with nested L3 */
              html += '<li class="wq-mega-menu__drawer-l2-expandable">';
              html += '<div class="wq-mega-menu__drawer-l2-header">';
              html += '<a href="' + esc(linkFor(child)) + '">' + esc(child.label) + '</a>';
              html += '<button class="wq-mega-menu__drawer-l3-toggle" aria-expanded="false" aria-label="Expand ' + esc(child.label) + '">'
                + '<svg class="wq-mega-menu__drawer-l3-chevron" width="10" height="10" viewBox="0 0 12 12"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                + '</button>';
              html += '</div>';
              html += '<ul class="wq-mega-menu__drawer-l3" aria-hidden="true">';
              child.children.forEach(function(l3) {
                html += '<li><a href="' + esc(linkFor(l3)) + '">' + esc(l3.label) + '</a></li>';
              });
              html += '</ul></li>';
            } else {
              html += '<li><a href="' + esc(linkFor(child)) + '">' + esc(child.label) + '</a></li>';
            }
          });

          html += '<li><a href="' + esc(linkFor(cat)) + '" class="wq-mega-menu__drawer-view-all">View All &rarr;</a></li>';
          html += '</ul>';
        } else {
          html += '<a href="' + esc(linkFor(cat)) + '" class="wq-mega-menu__drawer-l1-link">' + esc(cat.label) + '</a>';
        }
        html += '</li>';
      });

      html += '</ul></div>';
    });

    /* Link tabs at bottom */
    html += '<div class="wq-mega-menu__drawer-secondary">';
    tabs.forEach(function(tab) {
      if (tab.type === 'link') {
        html += '<a href="' + esc(tab.url) + '">' + esc(tab.label) + '</a>';
      }
    });
    /* Add Contact Us link */
    html += '<a href="/pages/contact">Contact Us</a>';
    html += '</div>';

    container.innerHTML = html;
  }

  /* ── 4a. Desktop event handlers ── */
  function initDesktopEvents(nav, groups) {
    var dropdown = nav.querySelector('#wq-mega-dropdown');
    var backdrop = nav.querySelector('.wq-mega-menu__backdrop');
    if (!dropdown || !backdrop) return;

    /* Tab hover/click — each mega tab opens its group panel */
    var tabItems = nav.querySelectorAll('.wq-mega-menu__tab--mega');
    tabItems.forEach(function(tabLi) {
      var btn = tabLi.querySelector('.wq-mega-menu__tab-btn');
      var groupId = tabLi.dataset.megaGroup;

      tabLi.addEventListener('mouseenter', function() {
        openGroup(nav, dropdown, backdrop, groupId);
      });
      tabLi.addEventListener('mouseleave', function() {
        scheduleClose(nav, dropdown, backdrop);
      });

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (activeTabId === groupId && dropdown.getAttribute('aria-hidden') === 'false') {
          closeDropdown(nav, dropdown, backdrop);
        } else {
          openGroup(nav, dropdown, backdrop, groupId);
        }
      });
    });

    /* Keep open when hovering dropdown */
    dropdown.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
    dropdown.addEventListener('mouseleave', function() { scheduleClose(nav, dropdown, backdrop); });

    /* Close on backdrop click */
    backdrop.addEventListener('click', function() { closeDropdown(nav, dropdown, backdrop); });

    /* L1 hover → show L2 panel (delegated) */
    dropdown.addEventListener('mouseover', function(e) {
      var l1Item = e.target.closest('.wq-mega-menu__l1-item');
      if (!l1Item) return;

      var groupPanel = l1Item.closest('.wq-mega-menu__group-panel');
      if (!groupPanel) return;

      activateL1(groupPanel, l1Item.dataset.category);
    });
  }

  function openGroup(nav, dropdown, backdrop, groupId) {
    clearTimeout(closeTimer);
    activeTabId = groupId;

    /* Deactivate all tab buttons */
    nav.querySelectorAll('.wq-mega-menu__tab-btn').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    /* Activate target tab button */
    var targetBtn = nav.querySelector('[data-mega-trigger="' + groupId + '"]');
    if (targetBtn) targetBtn.setAttribute('aria-expanded', 'true');

    /* Show dropdown */
    dropdown.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');

    /* Show correct group panel, hide others */
    dropdown.querySelectorAll('.wq-mega-menu__group-panel').forEach(function(panel) {
      panel.setAttribute('aria-hidden', panel.dataset.group !== groupId ? 'true' : 'false');
    });

    /* Activate first L1 in the group */
    var activePanel = dropdown.querySelector('.wq-mega-menu__group-panel[data-group="' + groupId + '"]');
    if (activePanel) {
      var firstL1 = activePanel.querySelector('.wq-mega-menu__l1-item');
      if (firstL1) {
        activateL1(activePanel, firstL1.dataset.category);
      }
    }
  }

  function closeDropdown(nav, dropdown, backdrop) {
    activeTabId = null;
    nav.querySelectorAll('.wq-mega-menu__tab-btn').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    dropdown.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');

    /* Reset L1 active states */
    dropdown.querySelectorAll('.wq-mega-menu__l1-item--active').forEach(function(item) {
      item.classList.remove('wq-mega-menu__l1-item--active');
    });
    dropdown.querySelectorAll('.wq-mega-menu__l2-panel').forEach(function(panel) {
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function scheduleClose(nav, dropdown, backdrop) {
    closeTimer = setTimeout(function() { closeDropdown(nav, dropdown, backdrop); }, CLOSE_DELAY);
  }

  function activateL1(groupPanel, categoryId) {
    /* Deactivate all L1 in this group */
    groupPanel.querySelectorAll('.wq-mega-menu__l1-item').forEach(function(item) {
      item.classList.remove('wq-mega-menu__l1-item--active');
    });
    groupPanel.querySelectorAll('.wq-mega-menu__l2-panel').forEach(function(panel) {
      panel.setAttribute('aria-hidden', 'true');
    });

    /* Activate current */
    var item = groupPanel.querySelector('.wq-mega-menu__l1-item[data-category="' + categoryId + '"]');
    if (item) item.classList.add('wq-mega-menu__l1-item--active');

    var panel = groupPanel.querySelector('.wq-mega-menu__l2-panel[data-panel="' + categoryId + '"]');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  /* ── 4b. Mobile event handlers ── */
  function initMobileEvents(nav) {
    var toggle = nav.querySelector('.wq-mega-menu__mobile-toggle');
    var drawer = nav.querySelector('#wq-mega-menu-drawer');
    var closeBtn = nav.querySelector('.wq-mega-menu__drawer-close');
    var drawerBackdrop = nav.querySelector('.wq-mega-menu__drawer-backdrop');

    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      drawerBackdrop.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { closeBtn && closeBtn.focus(); }, 100);
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawerBackdrop.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    drawerBackdrop.addEventListener('click', closeDrawer);

    /* Accordion expand/collapse — delegated events */
    drawer.addEventListener('click', function(e) {
      /* L1 accordion */
      var l1Btn = e.target.closest('.wq-mega-menu__drawer-l1-btn');
      if (l1Btn) {
        var l2 = l1Btn.nextElementSibling;
        var isExpanded = l1Btn.getAttribute('aria-expanded') === 'true';

        /* Close siblings within same group */
        var group = l1Btn.closest('.wq-mega-menu__drawer-group');
        if (group) {
          group.querySelectorAll('.wq-mega-menu__drawer-l1-btn').forEach(function(otherBtn) {
            if (otherBtn !== l1Btn) {
              otherBtn.setAttribute('aria-expanded', 'false');
              var otherL2 = otherBtn.nextElementSibling;
              if (otherL2) otherL2.setAttribute('aria-hidden', 'true');
            }
          });
        }

        l1Btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        if (l2) l2.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
        return;
      }

      /* L3 toggle */
      var l3Toggle = e.target.closest('.wq-mega-menu__drawer-l3-toggle');
      if (l3Toggle) {
        e.stopPropagation();
        var l3List = l3Toggle.closest('.wq-mega-menu__drawer-l2-expandable').querySelector('.wq-mega-menu__drawer-l3');
        var isExp = l3Toggle.getAttribute('aria-expanded') === 'true';
        l3Toggle.setAttribute('aria-expanded', isExp ? 'false' : 'true');
        if (l3List) l3List.setAttribute('aria-hidden', isExp ? 'true' : 'false');
      }
    });
  }

  /* ── 4c. Keyboard navigation ── */
  function initKeyboard(nav) {
    nav.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var dropdown = nav.querySelector('#wq-mega-dropdown');
        var backdrop = nav.querySelector('.wq-mega-menu__backdrop');
        var drawer = nav.querySelector('#wq-mega-menu-drawer');

        if (dropdown && dropdown.getAttribute('aria-hidden') === 'false') {
          closeDropdown(nav, dropdown, backdrop);
          var activeBtn = nav.querySelector('.wq-mega-menu__tab-btn[aria-expanded="true"]');
          if (activeBtn) activeBtn.focus();
        }

        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          drawer.setAttribute('aria-hidden', 'true');
          nav.querySelector('.wq-mega-menu__drawer-backdrop').setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          nav.querySelector('.wq-mega-menu__mobile-toggle').focus();
        }
      }
    });
  }

  /* Auto-init when DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { init: init };
})();
// cache-bust: 20260506-103514
